export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does Liz Luxes Services Cleaning serve?",
    a: "We're based in Orange Park, FL and cover roughly a 20-mile radius — Fleming Island, Oakleaf Plantation, Middleburg, Green Cove Springs, Doctors Inlet, Lakeside, Bellair-Meadowbrook Terrace, Jacksonville, Mandarin, Ortega, Riverside-Avondale, San Marco, Argyle Forest, Fruit Cove, Julington Creek, St. Johns, and Switzerland. We also travel to St. Augustine and Fernandina Beach with advance booking.",
  },
  {
    q: "What services do you offer?",
    a: "Deep cleaning, residential cleaning, office cleaning, commercial cleaning, move in / move out cleaning, recurring weekly, bi-weekly and monthly plans, Airbnb and short-term rental turnovers, clinic and medical office cleaning, closet organization, and laundry service.",
  },
  {
    q: "How much does a cleaning cost?",
    a: "Pricing depends on the size of the space, the type of clean, and how often you book. A recurring bi-weekly clean costs less per visit than a one-time deep clean or a move-out. Tell us the details and we'll send a free written estimate — no obligation and no pressure.",
  },
  {
    q: "Do you bring your own supplies and equipment?",
    a: "Yes. Our team arrives with professional cleaning products and equipment, so you don't need to provide anything. If you'd prefer we use a specific product in your home, just tell us and we'll work with it.",
  },
  {
    q: "What hours are you open?",
    a: "We're open 7 days a week, 7:00 AM to 9:00 PM — including evenings and weekends. That lets us clean offices, clinics, and storefronts outside business hours, and fit residential visits around your work schedule.",
  },
  {
    q: "Do you offer discounts for repeat customers?",
    a: "Yes. Returning customers and referrals receive a discount on every visit. The exact amount depends on the size of the job and your service area, so ask when you request your estimate and we'll build it into your quote.",
  },
  {
    q: "What's the difference between a deep clean and a regular clean?",
    a: "A regular clean covers ongoing maintenance — kitchens, bathrooms, floors, dusting, and high-touch surfaces. A deep clean adds the detail work: baseboards, door frames, inside appliances, grout, blinds, vents, ceiling fans, and window tracks. Most clients start with a deep clean, then switch to recurring service to maintain it.",
  },
  {
    q: "Can you handle Airbnb and short-term rental turnovers?",
    a: "Absolutely. We turn properties over between check-out and check-in with a full clean, fresh linens, restocking, and staging so the space matches your listing photos. We send photo confirmation once the property is guest-ready.",
  },
  {
    q: "Do you clean clinics and medical offices?",
    a: "Yes. We clean clinics, dental offices, therapy practices, and medical suites using a disinfection-first process on waiting rooms, exam rooms, restrooms, and high-touch surfaces — scheduled outside patient hours so your practice never pauses.",
  },
  {
    q: "How do I book?",
    a: "Call or text (904) 600-6466, email lissetgonzalezf70@gmail.com, or send us a request through the estimate form on this site. Tell us your address, the type of space, and roughly when you'd like us — we'll reply with pricing and available windows.",
  },
];
